module.exports = __webpack_public_path__ + "static/media/num1.090fc345.svg";